// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ActivatePaymentRuleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/activate_payment_rule/{rule_id}
 *
 * Activates a payment rule. No body required — rule_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Payroll_ActivatePaymentRuleInput {}

registerContract('Payroll_ActivatePaymentRuleInput', {})
